import { Link } from "react-router-dom";
import { COLLECTIONS, POSTERS } from "@/lib/collections";
import { ChevronRight, Sparkles } from "lucide-react";

export default function CollectionsIndex() {
    return (
        <div className="bg-[#F8F5EE]">
            <section className="relative py-20 lg:py-28" style={{ background: "linear-gradient(160deg,#03102A 0%,#041126 55%,#07204A 100%)" }} data-theme="dark">
                <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
                    <div className="eyebrow">Nos univers de service</div>
                    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mt-4 leading-tight">Les cinq collections</h1>
                    <p className="text-white/75 mt-6 max-w-2xl mx-auto leading-relaxed">Cinq univers, cinq pierres, un même engagement d'excellence. Choisissez la collection qui reflète vos besoins.</p>
                </div>
            </section>

            <section className="max-w-4xl mx-auto px-5 lg:px-8 pt-14">
                <div className="rounded-2xl overflow-hidden bg-[#03102A] shadow-[0_30px_60px_-24px_rgba(4,17,38,0.35)] border border-kgd-gold/20">
                    <div className="card-contain">
                        <img src={POSTERS.ensemble} alt="Aperçu des cinq collections Ménage KGD" loading="lazy"/>
                    </div>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14 lg:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-7">
                {COLLECTIONS.map((c) => (
                    <Link key={c.slug} to={`/collections/${c.slug}`} data-testid={`ci-${c.slug}`} className="group block luxe-card overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-24px_rgba(4,17,38,0.28)]" style={{ borderColor: `${c.border}55` }}>
                        <div className="card-square">
                            <img src={c.poster} alt={`Collection ${c.name}`} loading="lazy" className="transition-transform duration-[900ms] group-hover:scale-[1.03]"/>
                        </div>
                        <div className="px-5 py-4 sm:px-6 sm:py-5 flex items-center justify-between gap-3 border-t border-kgd-gold/15">
                            <div className="min-w-0">
                                <div className="eyebrow">Collection {c.name}</div>
                                <div className="text-sm text-[#041126]/80 mt-0.5 truncate">{c.subtitle}</div>
                            </div>
                            <span data-testid={`ci-cta-${c.slug}`} className="inline-flex items-center gap-1.5 text-sm font-medium whitespace-nowrap" style={{ color: c.primary }}>
                                Découvrir <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1"/>
                            </span>
                        </div>
                    </Link>
                ))}
            </section>

            <section className="max-w-3xl mx-auto px-5 lg:px-8 pb-24 text-center">
                <div className="gold-hairline w-24 mx-auto opacity-70"/>
                <p className="text-slate-600 mt-8">Vous hésitez entre deux collections?</p>
                <Link to="/soumission" className="btn-kgd mt-4 inline-flex" data-testid="ci-final-cta"><Sparkles className="w-4 h-4"/> Planifier mon évaluation gratuite</Link>
                <p className="mt-3 text-xs sm:text-sm text-slate-500">Visite des lieux, discussion de vos besoins et soumission personnalisée.</p>
            </section>
        </div>
    );
}
